var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubjectType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 56,
    height: 56,
    rx: 24,
    fill: "#F1E9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M35.6663 14.667H22.333C20.1239 14.667 18.333 16.4579 18.333 18.667V37.3337H39.6663V18.667C39.6663 16.4579 37.8755 14.667 35.6663 14.667Z",
    fill: "#1C0054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.666 21.334C22.666 20.7817 23.1137 20.334 23.666 20.334H34.3327C34.885 20.334 35.3327 20.7817 35.3327 21.334C35.3327 21.8863 34.885 22.334 34.3327 22.334H23.666C23.1137 22.334 22.666 21.8863 22.666 21.334Z",
    fill: "#1C0054"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.666 26.667C22.666 26.1147 23.1137 25.667 23.666 25.667H28.9993C29.5516 25.667 29.9993 26.1147 29.9993 26.667C29.9993 27.2193 29.5516 27.667 28.9993 27.667H23.666C23.1137 27.667 22.666 27.2193 22.666 26.667Z",
    fill: "#1C0054"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6663 33.334H22.333C20.1239 33.334 18.333 35.1248 18.333 37.334C18.333 39.5431 20.1239 41.334 22.333 41.334H35.6663C37.8755 41.334 39.6663 39.5431 39.6663 37.334V33.334Z",
    fill: "#1C0054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubjectType);
export default __webpack_public_path__ + "static/media/subject-type.5a947553f33077dda2660b9bc7cc447c.svg";
export { ForwardRef as ReactComponent };